import { Button, Modal, Form, Row, Col, Select, message } from "antd";
import { useEffect, useState } from "react";
import { AiOutlineCheck } from "react-icons/ai";
import Divider from "../../../../components/shared/Divider";
import patchDataClaim from "../../../../services/patchDataClaim";

const { Option } = Select;

export default function UpdateUser({
  isVisible,
  selected,
  setUpdateModal,
  refetch,
}: any) {
  const [isLoading] = useState(false);
  const [isRevoked, setRevoked] = useState(false);

  const [form] = Form.useForm();

  const onSubmit = async () => {
    const values = await form.getFieldsValue();

    const { aprLevel } = values;
    if (aprLevel === 0) {
      message.error("Approval Level must be 1 or 2");
      return;
    }
    const data = { aprLevel: aprLevel, isRevoked };
    const uri = `claim/claimers/${selected?._id}/update/level`;
    const response = await patchDataClaim(data, uri);
    if (response.success) {
      message.success("Updated Successfully");
      await refetch();
      setRevoked(false);
      form.resetFields();
      hideModal();
    } else {
      message.error(response.message);
    }
  };

  const hideModal = () => {
    setUpdateModal(false);
  };

  useEffect(() => {
    form.resetFields();
  }, [selected]);

  return (
    <Modal
      open={isVisible}
      title="Change Level"
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={hideModal}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="udateUser"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="udateUser"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <span>Name : {selected?.name}</span>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="aprLevel"
              initialValue={selected?.aprLevel}
              rules={[
                {
                  required: true,
                  message: "Please select approval level",
                },
              ]}
            >
              <Select
                defaultValue={selected?.aprLevel}
                placeholder="Approval Level"
              >
                <Option value={1}>Approver Level 1</Option>
                <Option value={2}>Approver Level 2</Option>
              </Select>
            </Form.Item>
          </Col>

          <Divider title="OR" />
          <div className="flex justify-center items-center w-full">
            <button
              className="flex justify-center items-center p-1"
              onClick={() => setRevoked(!isRevoked)}
            >
              {isRevoked ? (
                <div className="w-6 h-6 border bg-green-500 flex justify-center items-center">
                  <AiOutlineCheck color="#FFFFFF" />
                </div>
              ) : (
                <div className="w-6 h-6 border"></div>
              )}
              <span className="ml-2">Revoke Approver Status</span>
            </button>
          </div>
        </Row>
      </Form>
    </Modal>
  );
}
